import { Injectable } from '@angular/core';
import {
  PersistentDrawerTab as SharedPersistentDrawerTab,
  SharedPersistentDrawerTabsService,
} from '@sbd-doug-frontend/shared/lib/shared-services/persistent-drawer-tabs.service';

export type PersistentDrawerTabType = string;
export type PersistentDrawerTab = SharedPersistentDrawerTab<PersistentDrawerTabType>;

@Injectable({
  providedIn: 'root',
})
export class PersistentDrawerTabsService extends SharedPersistentDrawerTabsService<PersistentDrawerTabType> {
  constructor() {
    super({
      storageKey: 'doug:persistent-drawer-tabs:v1',
      channelName: 'doug:persistent-drawer-tabs:channel',
    });
  }
}
